var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fullscreen",
    {
      ref: "fullscreen",
      staticClass: "fullscreen",
      on: { change: _vm.fullscreenChange }
    },
    [
      _c(
        "button",
        {
          staticClass: "button-adjust",
          attrs: { type: "button" },
          on: { click: _vm.toggle }
        },
        [_c("i", { class: _vm.buttonClass })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pagecenter" }, [
        _c("div", { staticClass: "pagecenterdetails" }, [
          _c(
            "div",
            { staticClass: "ticket-counter-wrapper full-screen-mode" },
            [
              _c("div", { staticClass: "ticket-counter" }, [
                _c("div", { staticClass: "top-title" }, [
                  _c("div", { staticClass: "logo" }, [
                    _c("img", {
                      attrs: {
                        src: "static/images/vvg-logo-white.png",
                        alt: "Velocity Vehicle Group"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "page-title" }, [
                    _vm._v(_vm._s(_vm.pageTitle))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "current-time" }, [
                    _vm._v(_vm._s(_vm.currentTime))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "middle-content container-fluid" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6 col-sm-6 form-group" }, [
                      _c("div", { staticClass: "section-box box-1" }, [
                        _c("div", { staticClass: "box-wrapper" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.frontCounterTitle))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "sub-title" }, [
                            _vm._v(_vm._s(_vm.todayAvgLabel))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "minutes" }, [
                            _vm._v(_vm._s(_vm.frontCounterAvgWaitTime))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "min-text" }, [
                            _vm._v(_vm._s(_vm.minutesLabel))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "information" }, [
                          _vm._v(_vm._s(_vm.weekAvgLabel) + " "),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.frontCounterWeekAvgTime))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6 col-sm-6 form-group" }, [
                      _c("div", { staticClass: "section-box box-2" }, [
                        _c("div", { staticClass: "box-wrapper" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.willCallTitle))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "sub-title" }, [
                            _vm._v(_vm._s(_vm.todayAvgLabel))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "minutes" }, [
                            _vm._v(_vm._s(_vm.willCallAvgWaitTime))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "min-text" }, [
                            _vm._v(_vm._s(_vm.minutesLabel))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "information" }, [
                          _vm._v(_vm._s(_vm.weekAvgLabel) + " "),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.willCallWeekAvgTime))])
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bottom-title" }, [
                  _c("img", {
                    staticClass: "icon-left",
                    attrs: { src: "static/images/ticket_arrow.png" }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(" Take a Number Below ")]),
                  _c("img", {
                    staticClass: "icon-right",
                    attrs: { src: "static/images/ticket_arrow.png" }
                  })
                ])
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85a5831e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85a5831e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TicketWaitingWindow.vue
// module id = null
// module chunks = 